import React from 'react'
import './card.css'
import project1 from '../../images/ecom-project.png';
import project2 from '../../images/resume-builder.png';
import project3 from '../../images/ecom-project-seller.png';
import project4 from '../../images/portfolio.png'
import project5 from '../../images/digitalagriculture.png';
import project6 from '../../images/github-finder.png'
import project7 from '../../images/accident-detection.png';
import { useState,useEffect } from 'react';

// Dummy data for the projects
const initialProjects = [
    { id: 1, title: 'E-commerce', imgSrc: project1, livelink:'https://royal-perfume-novelty.vercel.app/',githublink:'https://github.com/shyam1112' },
    { id: 2, title: 'E-commerce Seller', imgSrc: project3 , livelink:'https://ecomm-frontend-shopkeeper.vercel.app/',githublink:'https://github.com/shyam1112'},
    { id: 3, title: 'Digital Agriculture', imgSrc: project5 ,livelink:'https://digitalagriculture.netlify.app/',githublink:'https://github.com/shyam1112'},
    { id: 4, title: 'Career-Craft', imgSrc: project2, livelink:'',githublink:'https://github.com/shyam1112' },
    { id: 5, title: 'Portfolio-2', imgSrc: project4, livelink:'https://shyam1112.github.io/ShyamSardhara.github.io',githublink:'https://github.com/shyam1112' },
    { id: 6, title: 'Github-Profile-Finder', imgSrc: project6, livelink:'' ,githublink:'https://github.com/shyam1112'},
    { id: 7, title: 'Accident-Detection - AI', imgSrc: project7, livelink:'' ,githublink:'https://github.com/shyam1112'},

    
];

const Card = () => {
    const [visibleProjects, setVisibleProjects] = useState(initialProjects);

    return (
        <div class="container">
            <ul class="cards">
            {visibleProjects.map((project) => (
                <div key={project.id} >
                    <li class="card">
                         <div>
                             <h3 class="card-title">{project.title}</h3>
                             <h3 class="card-title"></h3>
                             <div class="card-content">
                                <img width={'220px'} height={'100px'} src={project.imgSrc} alt='project' />
                             </div>
                             <div>
                                 <a href={project.livelink} target='_blank'>Live Link</a>
                             </div>
                         </div>
                         <div class="card-link-wrapper">
                             <a href={project.githublink} class="card-link">Learn More</a>
                         </div>
                     </li>
                </div>
            ))}
            </ul>
        </div>
    );
};

export default Card;



// export default function Card() {
//     return (
//         <div>

//             <div class="container">

//                 <ul class="cards">
//                     {/* <li class="card">
//                         <div>
//                             <h3 class="card-title">E-commerce</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project1} alt='project1' />
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="https://github.com/shyam1112" class="card-link">Learn More</a>
//                         </div>
//                     </li>
//                     <li class="card">
//                         <div>
//                             <h3 class="card-title">E-commerce</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project1} alt='project1' />
//                             </div>
//                             <div>
//                                 <a href='https://royal-perfume-novelty.vercel.app/'  target='_blank'>Live-Link</a>
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="https://github.com/shyam1112" class="card-link">Learn More</a>
//                         </div>
//                     </li> */}
//                     <li class="card">
//                         <div>
//                             <h3 class="card-title">E-commerce</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project1} alt='project1' />
//                             </div>
//                             <div>
//                                 <a href='https://royal-perfume-novelty.vercel.app/' target='_blank'>Live-Link</a>
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="https://github.com/shyam1112" class="card-link">Learn More</a>
//                         </div>
//                     </li>
//                     <li class="card">
//                         <div>
//                             <h3 class="card-title">Career-Craft</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project2} alt='project2' />
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="https://github.com/shyam1112" class="card-link">Learn More</a>
//                         </div>
//                     </li><li class="card">
//                         <div>
//                             <h3 class="card-title">E-commerce-seller</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project3} alt='project3' />
//                             </div>

                           
//                             <div>
//                                 <a href='https://ecomm-frontend-shopkeeper.vercel.app/' target='_blank'>Live-Link</a>
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="https://github.com/shyam1112" class="card-link">Learn More</a>
//                         </div>
//                     </li><li class="card">
//                         <div>
//                             <h3 class="card-title">Digital Agriculture</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project5} alt='project5' />
//                             </div>
//                             <div>
//                                 <a href='https://digitalagriculture.netlify.app/' target='_blank'>Live-Link</a>
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="" class="card-link">Learn More</a>
//                         </div>
//                     </li><li class="card">
//                         <div>
//                             <h3 class="card-title">Portfolio-2</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project4} alt='project1' />
//                             </div>
//                             <div>
//                                 <a href='https://shyam1112.github.io/ShyamSardhara.github.io' target='_blank'>Live-Link</a>
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="" class="card-link">Learn More</a>
//                         </div>
//                     </li>
                    
//                     <li class="card">
//                         <div>
//                             <h3 class="card-title">Github-Profile-Finder</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project6} alt='project1' />
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="" class="card-link">Learn More</a>
//                         </div>
//                     </li>
                    
                    
//                     <li class="card">
//                         <div>
//                             <h3 class="card-title">Accident-Detection by using AI</h3>
//                             <div class="card-content">
//                                <img width={'200px'} src={project7} alt='project7' />
//                             </div>
//                         </div>
//                         <div class="card-link-wrapper">
//                             <a href="" class="card-link">Learn More</a>
//                         </div>
//                     </li>
                   
//                 </ul>
//             </div>
//         </div>
//     )
// }
